import { endOfDay, startOfDay } from 'date-fns';

export const todayRange: [number, number] = [
  startOfDay(Date.now()).getTime(),
  endOfDay(Date.now()).getTime(),
];
